import type { NextPage } from "next";

import { BW_VARIANT } from "@components/BridgeWrapV2/types";
import BridgeWrapV2 from "@components/BridgeWrapV2/BridgeWrapV2";
import useLedgerCookies from "@hooks/useLedgerCookies";
// import Wrap from "@components/Wrap";

const WrapPage: NextPage = () => {
  useLedgerCookies();
  return <BridgeWrapV2 variant={BW_VARIANT.AGETH} />;
};

export default WrapPage;
